import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, ExternalLink, Home, Calendar, Hash, PartyPopper } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
export function AdditionalPaymentThankYouPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderCopied, setOrderCopied] = useState(false);
  const name = searchParams.get('name') || 'חבר';
  const email = searchParams.get('email') || '';
  const orderNumber = searchParams.get('orderNumber') || '';
  const handleCopyOrderNumber = () => {
    navigator.clipboard.writeText(orderNumber);
    setOrderCopied(true);
    setTimeout(() => setOrderCopied(false), 2000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'התשלום התקבל! - Water Tribe Fest 2026';
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-cyan-50 to-white" dir="rtl" data-id="element-848" data-mp="1kfnqf010mseg">
      <Navigation data-id="element-849" data-mp="1fh41qrv1f2ie" />

      <div className="container mx-auto px-4 py-20" data-id="element-850" data-mp="1fhm7qg7i4v3i">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-851" data-mp="1u4xiifvv0b2k">
          {/* Success Icon */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="flex justify-center mb-8" data-id="element-852" data-mp="1y5hevh8lzann">
            <div className="bg-cyan-100 rounded-full p-6" data-id="element-853" data-mp="irms61sxowbf">
              <CheckCircle className="w-20 h-20 text-cyan-600" data-id="element-854" data-mp="drh2gr685jvz" />
            </div>
          </motion.div>

          {/* Thank You Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-center mb-12" data-id="element-855" data-mp="13gxnpu1dci3i">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-856" data-mp="1mdfary59vttf">
              מעולה {name}! 🌊
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-857" data-mp="1qe910y66tkph">
              התשלום התקבל בהצלחה — מקומך בפסטיבל מובטח!
            </p>
          </motion.div>

          {/* Upgraded Dates Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.45
        }} className="bg-gradient-to-br from-[#0A5F8F] to-cyan-600 rounded-2xl p-6 md:p-8 shadow-lg mb-8 text-white text-center" data-id="element-858" data-mp="2053og5v66qci">
            <Calendar className="w-10 h-10 mx-auto mb-4 text-cyan-200" data-id="element-859" data-mp="3plpouu9aht6g" />
            <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-860" data-mp="3kmmlde8yjv0l">
              נתראה בתאריכים החדשים!
            </h2>
            <p className="text-3xl md:text-4xl font-black text-cyan-200 mb-3" data-id="element-861" data-mp="3fol3gwn9q1qp">
              19-21 בנובמבר 2026
            </p>
            <p className="text-cyan-100 text-lg" data-id="element-862" data-mp="h5miqsxtsck8">
              חוף מעגן עדן, כנרת — שיא העונה 🌞
            </p>
          </motion.div>

          {/* Order Number Card */}
          {orderNumber && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-cyan-200 mb-8" data-id="element-863" data-mp="7erx9qselgzu">
              <div className="flex items-center gap-3 mb-4" data-id="element-864" data-mp="fmcica7ezi77">
                <div className="bg-cyan-100 rounded-full p-2" data-id="element-865" data-mp="knjrodp7gpfz">
                  <Hash className="w-6 h-6 text-cyan-600" data-id="element-866" data-mp="kkxm2jlvkk0e" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-867" data-mp="5rkkd59x6tbw">
                  מספר הזמנה
                </h2>
              </div>

              <p className="text-gray-600 mb-4" data-id="element-868" data-mp="yeoqxeonvfps">
                מספר ההזמנה של תוספת התשלום. שמור אותו לצורך התכתבות.
              </p>

              <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-6 border-2 border-cyan-100" data-id="element-869" data-mp="13c6wqw7dtetk">
                <div className="flex items-center justify-between gap-4" data-id="element-870" data-mp="ooc1p95wiydb">
                  <div className="flex-1" data-id="element-871" data-mp="tmduwmx1ke2i">
                    <p className="text-sm text-gray-600 mb-2" data-id="element-872" data-mp="tlc8jmaks55h">
                      מספר ההזמנה שלך:
                    </p>
                    <p className="text-3xl md:text-4xl font-black text-cyan-600 tracking-wider" data-id="element-873" data-mp="1m4j6w54a1ke9">
                      {orderNumber}
                    </p>
                  </div>
                  <button onClick={handleCopyOrderNumber} className="bg-cyan-100 hover:bg-cyan-200 p-4 rounded-xl transition-colors shrink-0" data-id="element-874" data-mp="31vbob7fxd5tx">
                    {orderCopied ? <CheckCircle className="w-6 h-6 text-cyan-600" data-id="element-875" data-mp="3bm6aycx327fw" /> : <Copy className="w-6 h-6 text-cyan-600" data-id="element-876" data-mp="2nwlohk1q0s1v" />}
                  </button>
                </div>
              </div>
            </motion.div>}

          {/* Billing Announcement */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55
        }} className="bg-amber-50 rounded-2xl p-6 md:p-8 shadow-lg border-2 border-amber-300 mb-8" data-id="element-877" data-mp="2wxjwsej6zlq9">
            <div className="flex items-start gap-4" data-id="element-878" data-mp="30xtpvaw0ebm4">
              <div className="bg-amber-200 rounded-full p-3 shrink-0 mt-0.5" data-id="element-879" data-mp="31198gnow62sa">
                <span className="text-2xl" data-id="element-880" data-mp="35w51nr5v6w6z">⚠️</span>
              </div>
              <div data-id="element-881" data-mp="3aydu8metrw8k">
                <h3 className="text-xl md:text-2xl font-black text-amber-900 mb-2" data-id="element-882" data-mp="3axuad05m6xrw">
                  שימו לב! ❤️
                </h3>
                <p className="text-lg font-semibold text-amber-800 leading-relaxed" data-id="element-883" data-mp="2i8djw81k1qyb">
                  החיוב יופיע מחברת{' '}
                  <span className="font-black text-amber-950" data-id="element-884" data-mp="2n6oz6yamctnx">
                    "אנרצ'י רפואה משלימה"
                  </span>
                  , סכום החיוב יהיה ₪240.
                </p>
              </div>
            </div>
          </motion.div>

          {/* WhatsApp Group */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-8" data-id="element-885" data-mp="1zifg444sik0h">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-886" data-mp="1qyslp1vukuw2">לא לשכוח!</h3>
            <div className="flex items-start gap-4" data-id="element-887" data-mp="1mxqjqdajq4qe">
              <div className="bg-green-100 rounded-full p-2 shrink-0" data-id="element-888" data-mp="1i0gw936pw357">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-889" data-mp="1i2bc4334t52f" />
              </div>
              <div data-id="element-890" data-mp="1d2f5rx6yp1jp">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-891" data-mp="1d2ypnjg6a00d">
                  קבוצת הווטסאפ של הפסטיבל
                </h4>
                <p className="text-gray-600 mb-2" data-id="element-892" data-mp="13asy2atu1klp">
                  הישארו מעודכנים עם כל הפרטים החשובים לקראת הפסטיבל
                </p>
                <a href="https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA" target="_blank" rel="noopener noreferrer" className="text-[#0A5F8F] hover:underline font-semibold inline-flex items-center gap-2" data-id="element-893" data-mp="zbadxh9u5djx">
                  לחצו כאן להצטרפות לקבוצה
                  <ExternalLink className="w-4 h-4" data-id="element-894" data-mp="2i7bz63y0w9x2" />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Back to Festival Button */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-center" data-id="element-895" data-mp="249nfv0jltau4">
            <Button onClick={() => navigate('/water-tribe-fest')} variant="outline" className="inline-flex items-center gap-2" data-id="element-896" data-mp="1z9ht9ys6yeiw">
              <Home className="w-5 h-5" data-id="element-897" data-mp="1phvczo0zxp9a" />
              חזרה לדף הפסטיבל
            </Button>
          </motion.div>
        </motion.div>
      </div>

      <Footer data-id="element-898" data-mp="1bkynpr0j0fui" />
    </div>;
}